import { Box, Button, Typography } from '@mui/material';

import useTranslation from '../../hooks/useTranslation';
import { ErrorMessage } from '../ErrorMessage';
import { BoxStyles, ButtonStyles, TypographyStyles } from './Login.styles';
import LoginButton from './LoginButton';

type Props = {
    dispatchInitAuthentication: () => void;
    dispatchCancelAuthentication?: () => void;
    error?: string | null | undefined;
};

export const LoginForm = ({ dispatchInitAuthentication, dispatchCancelAuthentication, error }: Props) => {
    const translate = useTranslation();

    return (
        <>
            <Typography variant="h1" color="primary" textAlign="center" sx={TypographyStyles}>
                <>{translate('page.authentication.submit.log.in.title')}</>
            </Typography>

            {error && (
                <ErrorMessage
                    title={translate('page.authentication.submit.log.in.error.title')}
                    description={translate('page.authentication.submit.log.in.error.description')}
                    sx={{ mt: '50px', mb: '70px' }}
                />
            )}

            <Box display="flex" justifyContent="center">
                <LoginButton dispatchInitAuthentication={dispatchInitAuthentication} translate={translate} />
            </Box>

            {error && dispatchCancelAuthentication && (
                <Box display="flex" justifyContent="center" sx={BoxStyles}>
                    <Button fullWidth variant="outlined" onClick={dispatchCancelAuthentication} sx={ButtonStyles}>
                        {translate('page.authentication.submit.log.in.cancel')}
                    </Button>
                </Box>
            )}
        </>
    );
};

export default LoginForm;
